<template>
  <div class="card m-0 mr-1 pdbinfo-card">
    <div class="card-header bg-white m-0 p-0">
      <i
        class="mr-1 ml-1 far"
        :class="{
          'fa-check-square': pdbInfo.selected,
          'text-success': pdbInfo.selected,
          'fa-square': !pdbInfo.selected,
          'text-warning': !selectionEnabled() && !pdbInfo.selected,
        }"
        v-on:click="addtocart()"
        data-toggle="popover"
        data-trigger="hover"
        data-placement="top"
        :data-content="
          selectionEnabled()
            ? 'Add structure to analysis cart.'
            : 'Cart is full. Remove some structures first.'
        "
      ></i>

      <ModelingBtn :pdbInfo="pdbInfo"></ModelingBtn>

      <i
        class="icofont-atom p-1"
        v-if="hasLigand()"
        :aria-label="pdbInfo.ligands.length + ' ligands.'"
        data-toggle="popover"
        data-placement="top"
        data-trigger="hover"
        :data-content="pdbInfo.ligands.length + ' ligands.'"
      ></i>

      <i
        class="fas fa-cubes p-1"
        v-if="pdbInfo.isComplex"
        aria-label="Part of a heterocomplex."
        data-toggle="popover"
        data-placement="top"
        data-trigger="hover"
        data-content="Part of a heterocomplex."
      ></i>
    </div>
    <div class="card-body text-center p-1">
      <span v-if="pdbInfo.imgs.length === 0">
        <img
          :src="imageLink"
          style="margin: auto"
          class="img-responsive img-representative-tmb"
          width="80px"
        />
      </span>
      <span v-if="pdbInfo.imgs.length === 1">
        <img
          :src="pdbInfo.imgs[0]"
          style="margin: auto"
          class="img-responsive img-representative-tmb"
        />
      </span>
      <span v-if="pdbInfo.imgs.length > 1">
        <img
          :src="pdbInfo.slide"
          style="margin: auto"
          class="img-responsive img-representative-tmb"
        />
        <!-- ng-mouseenter="startAnimation(r)"
        ng-mouseleave="stopAnimation(r)"-->
      </span>
      <!--<img ng-src="http://modflex.org/thumbnails/{{pdbInfo.pdb}}{{pdbInfo.chain}}.{{hit.masterID}}.jpg" style="margin:auto;" class="img-responsive img-representative-tmb">-->
      <div class="text-center">
        <span
          data-toggle="modal"
          :data-target="'#infoModal_' + pdbInfo.name"
          :id="'infoCircle_' + pdbInfo.pdb + pdbInfo.chain"
          class="infoCircle"
          title="Click to see details"
        >
          <i class="fa fa-info-circle"></i>
          {{ pdbInfo.pdb }}{{ pdbInfo.chain }}
          <sup>
            <span
              class="badge badge-pill badge-warning text-small"
              :aria-label="pdbInfo.members.length + ' members'"
              data-toggle="popover"
              data-placement="top"
              data-trigger="hover"
              :data-content="pdbInfo.members.length + ' members'"
              >{{ pdbInfo.members.length || 0 }}</span
            >
          </sup>
        </span>
      </div>
    </div>

    <!-- TODO: move to a component or parent-->
    <div
      class="modal fade"
      :id="'infoModal_' + pdbInfo.name"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'#infoModalLabel_' + pdbInfo.name"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="'infoModalLabel_' + pdbInfo.name">
              {{ pdbInfo.name }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <PDBItemInfo :pdbInfo="pdbInfo"></PDBItemInfo>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PDBCard",
  components: {
    ModelingBtn: () => import("../components/ModelingBtn"),
    PDBItemInfo: () => import("../components/PDBItemInfo"),
  },
  props: {
    pdbInfo: Object,
  },
  data: function () {
    return {
      myid: "",
    };
  },

  mounted() {
    var myDefaultWhiteList =
      window.jQuery.fn.tooltip.Constructor.Default.whiteList;
    var myCustomRegex = /^data-[\w]*$/i;
    myDefaultWhiteList["*"].push(myCustomRegex);

    const myid = "popover_" + this.pdbInfo.name;
    this.myid = myid;
  },
  watch: {
    pdbInfo: function (newPDB) {
      !newPDB.imgs && (newPDB.imgs = []);
    },
  },
  computed: {
    imageLink: function () {
      const p = this.pdbInfo.pdb;
      const prefix = p.substring(1, 3);
      return `https://cdn.rcsb.org/images/structures/${prefix}/${p}/${p}_assembly-1.jpeg`;
    },
  },
  methods: {
    addtocart: function () {
      if (!this.selectionEnabled()) {
        if (!this.pdbInfo.selected) return;
      }
      this.pdbInfo.selected = !this.pdbInfo.selected;
      if (this.pdbInfo.selected) this.$parent.incSelected();
      else this.$parent.decSelected();
    },
    selectionEnabled: function () {
      return this.$parent.canSelect();
    },
    hasLigand: function () {
      // return this.pdbInfo ? true : false;
      return this.pdbInfo.ligands && this.pdbInfo.ligands.length > 0;
    },
  },
};
</script>

<style scoped>
.pdbinfo-card {
  max-width: 125px;
}
.infoCircle {
  cursor: pointer;
}
.modal-body span {
  word-wrap: break-all !important;
}
</style>
